import styled from 'styled-components';
import { Tag, Typography } from 'antd';
import { ClockCircleOutlined, CalendarOutlined, CheckCircleFilled, PlayCircleFilled, CloseCircleFilled, EyeOutlined, ScheduleOutlined, ShareAltOutlined } from '@ant-design/icons';
import { AssignmentDisplayStatusV2 } from '@module/assignment';
import { CardSupportText, CardTitle, getColor, getSize, SecondaryButton } from '@lib/common';
import { AssignmentStatusComponent, getColorByAssignmentType, getDateTime } from '../utils';
import { AssignmentCountDownTimer } from './assignment-count-down-timer.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Text = Typography.Text;
var AssignmentCard = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__AssignmentCard",
  componentId: "sc-whl8c2-0"
})(["background-color:", ";border-radius:", ";padding:", ";transition:all 0.3s;border:1px solid ", ";box-shadow:0 1px 3px 0 rgba(0,0,0,0.07);display:flex;align-items:center;min-height:96px;&:hover{box-shadow:0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -2px rgba(0,0,0,0.1);border-color:", ";}"], getColor('fillBgWhite'), getSize('radiusSm'), getSize('padding16'), getColor('fillIntSubActive'), getColor('fillIntActive'));
var CardInner = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__CardInner",
  componentId: "sc-whl8c2-1"
})(["width:100%;display:flex;align-items:center;justify-content:flex-start;gap:", ";"], getSize('padding16'));
/** Stats + actions: pinned to the right edge of the card (after flexible main content). */

var RightCluster = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__RightCluster",
  componentId: "sc-whl8c2-2"
})(["display:flex;align-items:center;gap:", ";flex-shrink:0;margin-left:auto;"], getSize('padding16'));
var MainContent = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__MainContent",
  componentId: "sc-whl8c2-3"
})(["display:flex;align-items:center;gap:", ";flex:1;min-width:0;"], getSize('padding16'));
var StatusIconWrapper = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__StatusIconWrapper",
  componentId: "sc-whl8c2-4"
})(["width:40px;height:40px;border-radius:", ";display:flex;align-items:center;justify-content:center;", ";font-size:", ";"], getSize('radiusSm'), function (_ref) {
  var statusType = _ref.statusType;
  return getColorByAssignmentType(statusType);
}, getSize('typo20'));
var CardHeader = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__CardHeader",
  componentId: "sc-whl8c2-5"
})(["display:flex;flex-direction:column;gap:", ";"], getSize('padding8'));
var CardMetaRow = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__CardMetaRow",
  componentId: "sc-whl8c2-6"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:", ";"], getSize('padding4'));
var DetailItem = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__DetailItem",
  componentId: "sc-whl8c2-7"
})(["display:flex;align-items:center;gap:", ";font-size:", ";color:", ";margin-bottom:4px;&.important span{color:", ";font-weight:500;}.anticon{font-size:", ";}"], getSize('padding8'), getSize('typo14'), getColor('textIntSub'), getColor('textIntDefault'), getSize('typo16'));
var IdTag = styled(Tag).withConfig({
  displayName: "assignment-list-itemcomponent__IdTag",
  componentId: "sc-whl8c2-8"
})(["padding:0px 12px;font-size:12px;border-radius:", ";height:24px;line-height:24px;border:none;background-color:#f2f8ff;color:#64748b;"], getSize('radiusSm'));
var StatusLine = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__StatusLine",
  componentId: "sc-whl8c2-9"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:", ";"], getSize('padding4'));
var MetaLine = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__MetaLine",
  componentId: "sc-whl8c2-10"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:", ";"], getSize('padding12'));
var RightSection = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__RightSection",
  componentId: "sc-whl8c2-11"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:center;gap:", ";flex:0 0 160px;width:160px;min-width:160px;"], getSize('padding8'));
var ActionButtons = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__ActionButtons",
  componentId: "sc-whl8c2-12"
})(["display:flex;flex-direction:column;align-items:stretch;gap:", ";width:100%;"], getSize('padding8'));
var StyledActionButton = styled(SecondaryButton).withConfig({
  displayName: "assignment-list-itemcomponent__StyledActionButton",
  componentId: "sc-whl8c2-13"
})(["width:100%;justify-content:center;padding-left:", ";padding-right:", ";font-size:", ";"], getSize('padding8'), getSize('padding8'), getSize('typo13'));
var SubmittedCount = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__SubmittedCount",
  componentId: "sc-whl8c2-14"
})(["display:flex;flex-direction:column;align-items:center;justify-content:space-between;gap:", ";min-width:140px;"], getSize('padding12'));
var SubmittedLabel = styled.div.withConfig({
  displayName: "assignment-list-itemcomponent__SubmittedLabel",
  componentId: "sc-whl8c2-15"
})(["font-weight:bold;letter-spacing:0.08em;text-transform:uppercase;color:", ";"], getColor('textIntSub'));
export var AssignmentListItemComponent = function AssignmentListItemComponent(_ref2) {
  var assignment = _ref2.assignment,
      tableAssignmentTranslation = _ref2.tableAssignmentTranslation,
      onShareAssignment = _ref2.onShareAssignment,
      navigateToAssignmentDetail = _ref2.navigateToAssignmentDetail;

  var getTranslatedStatusName = function getTranslatedStatusName() {
    switch (assignment.displayStatus.value) {
      case AssignmentDisplayStatusV2.upComing.value:
        return {
          text: tableAssignmentTranslation.statusUpComing,
          icon: /*#__PURE__*/_jsx(ClockCircleOutlined, {})
        };

      case AssignmentDisplayStatusV2.onGoing.value:
        return {
          text: tableAssignmentTranslation.statusOnGoing,
          icon: /*#__PURE__*/_jsx(PlayCircleFilled, {})
        };

      case AssignmentDisplayStatusV2.completed.value:
        return {
          text: tableAssignmentTranslation.statusEnded,
          icon: /*#__PURE__*/_jsx(CloseCircleFilled, {})
        };

      case AssignmentDisplayStatusV2.completed.value:
        return {
          text: tableAssignmentTranslation.statusPublishedScore,
          icon: /*#__PURE__*/_jsx(CheckCircleFilled, {})
        };

      case AssignmentDisplayStatusV2.grading.value:
        return {
          text: tableAssignmentTranslation.statusGrading,
          icon: /*#__PURE__*/_jsx(ClockCircleOutlined, {})
        };

      default:
        return {
          text: assignment.displayStatus.value,
          icon: /*#__PURE__*/_jsx(CloseCircleFilled, {})
        };
    }
  };

  var statusConfig = getTranslatedStatusName();
  var startTimeText = assignment.startTime ? getDateTime(+assignment.startTime) : 'No set date';
  var endTimeText = assignment.endTime ? getDateTime(+assignment.endTime) : 'No set date';
  var isOnGoing = assignment.displayStatus.isOnGoing();
  var isUpComing = assignment.displayStatus.isUpComing();

  var getButtonText = function getButtonText() {
    switch (assignment.displayStatus.value) {
      case AssignmentDisplayStatusV2.onGoing.value:
        return tableAssignmentTranslation.actionFollow;

      case AssignmentDisplayStatusV2.completed.value:
        return tableAssignmentTranslation.actionReviewResult;

      case AssignmentDisplayStatusV2.grading.value:
        return tableAssignmentTranslation.actionGradingNow;

      default:
        return tableAssignmentTranslation.actionViewDetails;
    }
  };

  return /*#__PURE__*/_jsx(AssignmentCard, {
    children: /*#__PURE__*/_jsxs(CardInner, {
      children: [/*#__PURE__*/_jsx(MainContent, {
        children: /*#__PURE__*/_jsxs(CardHeader, {
          children: [/*#__PURE__*/_jsx(CardMetaRow, {
            children: /*#__PURE__*/_jsxs(StatusLine, {
              children: [/*#__PURE__*/_jsx(AssignmentStatusComponent, {
                statusType: assignment.displayStatus.value,
                text: statusConfig.text
              }), /*#__PURE__*/_jsxs(IdTag, {
                children: ["#", assignment.idNumber]
              }), isOnGoing && /*#__PURE__*/_jsx(AssignmentCountDownTimer, {
                endTimeUnix: assignment.endTime,
                onTimeout: function onTimeout() {
                  return window.location.reload();
                },
                labelBeforeTime: tableAssignmentTranslation.assignmentCountdownLabelPrefix,
                labelAfterTime: tableAssignmentTranslation.assignmentCountdownHours
              }), isUpComing && /*#__PURE__*/_jsx(AssignmentCountDownTimer, {
                endTimeUnix: assignment.startTime,
                onTimeout: function onTimeout() {
                  return window.location.reload();
                },
                labelBeforeTime: tableAssignmentTranslation.assignmentStartsIn,
                labelAfterTime: tableAssignmentTranslation.assignmentCountdownHours
              })]
            })
          }), /*#__PURE__*/_jsx(CardMetaRow, {
            children: /*#__PURE__*/_jsx(CardTitle, {
              children: assignment.title
            })
          }), /*#__PURE__*/_jsx(CardMetaRow, {
            children: /*#__PURE__*/_jsx(MetaLine, {
              children: /*#__PURE__*/_jsxs(DetailItem, {
                children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), /*#__PURE__*/_jsxs(Text, {
                  children: [tableAssignmentTranslation.durationAssignment, ":", ' ', assignment.duration != null ? "".concat(assignment.duration, " ").concat(tableAssignmentTranslation.minute) : '—']
                })]
              })
            })
          }), /*#__PURE__*/_jsx(CardMetaRow, {
            children: /*#__PURE__*/_jsxs(MetaLine, {
              children: [/*#__PURE__*/_jsxs(DetailItem, {
                children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), /*#__PURE__*/_jsxs(CardSupportText, {
                  children: [tableAssignmentTranslation.start, ": ", startTimeText]
                })]
              }), /*#__PURE__*/_jsxs(DetailItem, {
                children: [/*#__PURE__*/_jsx(ScheduleOutlined, {}), /*#__PURE__*/_jsxs(CardSupportText, {
                  children: [tableAssignmentTranslation.end, ": ", endTimeText]
                })]
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(RightCluster, {
        children: [/*#__PURE__*/_jsxs(SubmittedCount, {
          children: [/*#__PURE__*/_jsx(CardTitle, {
            children: assignment.totalAttendee
          }), /*#__PURE__*/_jsx(SubmittedLabel, {
            children: tableAssignmentTranslation.submitted || 'Submitted'
          })]
        }), /*#__PURE__*/_jsx(RightSection, {
          children: /*#__PURE__*/_jsxs(ActionButtons, {
            children: [/*#__PURE__*/_jsxs(StyledActionButton, {
              onClick: function onClick() {
                return onShareAssignment(assignment.id.toString(), assignment.title, assignment.idNumber);
              },
              children: [/*#__PURE__*/_jsx(ShareAltOutlined, {}), tableAssignmentTranslation.share]
            }), navigateToAssignmentDetail && /*#__PURE__*/_jsxs(StyledActionButton, {
              onClick: function onClick() {
                return navigateToAssignmentDetail(assignment);
              },
              children: [/*#__PURE__*/_jsx(EyeOutlined, {}), getButtonText()]
            })]
          })
        })]
      })]
    })
  });
};